const updateMainScreen = (state, action) => {
  if (state === undefined) {
    return {
      mainScreen: null,
      loading: false,
      trialChildren: [],
    };
  }

  switch (action.type) {
    case "MAIN_SCREEN_REQUEST":
      return {
        ...state.desktop,
        mainScreen: action.payload,
      };
    case "TRIAL_LIST":
      return {
        ...state.desktop,
        trialChildren: action.payload,
      };
    case "TRIAL_LIST_LOADING":
      return {
        ...state.desktop,
        loading: action.payload,
      };
    default:
      return state.desktop;
  }
};

export default updateMainScreen;
